import {IconSize, iconStrokeWidthBySize} from '../icon_types';

type SearchIconProps = {
  id?: string;
  className?: string;
  size: IconSize;
  color?: string;
};

const pathDsBySize = {
  '16': [
    'M15 15L11.6166 11.6167M13.4445 7.22223C13.4445 10.6587 10.6587 13.4445 7.22226 13.4445C3.7858 13.4445 1 10.6587 1 7.22223C1 3.78577 3.7858 0.999969 7.22226 0.999969C10.6587 0.999969 13.4445 3.78577 13.4445 7.22223Z',
  ],
  '24': [
    'M22 22L17.1667 17.1667M19.7778 10.8889C19.7778 15.7981 15.7981 19.7778 10.8889 19.7778C5.97969 19.7778 2 15.7981 2 10.8889C2 5.97969 5.97969 2 10.8889 2C15.7981 2 19.7778 5.97969 19.7778 10.8889Z',
  ],
  '32': [
    'M30 30.0001L23.2333 23.2334M26.889 14.4444C26.889 21.3174 21.3174 26.8889 14.4445 26.8889C7.5716 26.8889 2 21.3174 2 14.4444C2 7.57152 7.5716 1.99992 14.4445 1.99992C21.3174 1.99992 26.889 7.57152 26.889 14.4444Z',
  ],
};

const SearchIcon = (props: SearchIconProps) => {
  const {id, className, size, color} = props;
  const paths = pathDsBySize[size];
  const colorOptions = color || 'currentColor' || '#1E1E20';

  return (
    <svg
      id={id}
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none">
      <g clipPath={`url(#clip0_${size})`}>
        {paths.map((d, index) => (
          <path
            key={index}
            d={d}
            stroke={colorOptions}
            strokeWidth={iconStrokeWidthBySize[size]}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        ))}
      </g>
      <defs>
        <clipPath id={`clip0_${size}`}>
          <rect width={size} height={size} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SearchIcon;
